import React from "react";
import { MainContainer } from "./styles";

const PreviewData = () => {
  return (
    <MainContainer>
      <div className="indications">
        <h2 className="title">Previsualizar los datos</h2>
      </div>
    </MainContainer>
  );
};

export default PreviewData;